import React, { useState } from "react";
import KycComponent from "./KycComponent";
import SellerKycComponent from "./SellerKycComponent";

const KycModule = () => {
  const [activeTab, setActiveTab] = useState("Buyer");
  const tabs = ["Buyer", "Global Partner", "Seller"];

  const renderTabContent = () => {
    switch (activeTab) {
      case "Buyer":
        return <KycComponent mode="Buyer" />;
      case "Global Partner":
        return <KycComponent mode="GlobalPartner" />;
      case "Seller":
        return <SellerKycComponent />;
      default:
        return <KycComponent mode="Buyer" />;
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="mb-3 main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default KycModule;
